import { MessageCircle } from 'lucide-react';

export default function WhatsAppWidget() {
  const handleWhatsAppClick = () => {
    const phoneNumber = '917834909148';
    const message = encodeURIComponent('Hi! I would like to know more about your tutoring services.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <div
      data-testid="whatsapp-widget"
      className="whatsapp-float"
      onClick={handleWhatsAppClick}
      title="Chat on WhatsApp"
    >
      <MessageCircle size={30} />
    </div>
  );
}
